import { render, staticRenderFns } from "./ExtendedProfileQuestionTable.vue?vue&type=template&id=34c66f7c&"
import script from "./ExtendedProfileQuestionTable.vue?vue&type=script&lang=js&"
export * from "./ExtendedProfileQuestionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports